import { apiSlice } from "@/redux/apiSlice";
interface User {
    id: number;
    name: string;
    email: string;
    role: 'basic' | 'admin';
  }
export const mediaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    uploadMedia: builder.mutation({
        query: (body) => ({
            url: '/media/upload',
            method: 'POST',
            body: body,
          }),
          invalidatesTags: ['Media'],
      }),
      getProjectMedia: builder.query({
        query: (projectId) => `/media/project/${projectId}`,
        providesTags: ['Media'],
      }),
  }),
});


export const { useUploadMediaMutation,useGetProjectMediaQuery} = mediaApiSlice